import React from "react";

export default class SearchBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      q: this.props.q || "",
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  render() {
    return (
      <form
        className="search-bar"
        method="get"
        action={this.props.path}
        onSubmit={this.onSubmit}
        autoComplete="off"
      >
        <div className="input-group">
          <label style={{ display: "none" }} htmlFor="q">
            Search
          </label>
          <input
            className="form-control"
            type="text"
            placeholder={this.props.placeholder}
            name="q"
            id={"q" + this.props.viewport}
            autoComplete="off"
            value={this.state.q}
            onChange={this.onChange}
          />
          <span className="input-group-append">
            <button
              className="btn btn-primary"
              type="submit"
              aria-label="Search"
            >
              <span className="fa fa-search">&nbsp;</span>
            </button>
          </span>
        </div>
        {this.state.loading ? (
          <div className="loadingOverlay">
            <div className="spinner"></div>
          </div>
        ) : null}
      </form>
    );
  }

  onChange(e) {
    this.setState({ q: e.target.value });
  }

  onSubmit() {
    this.setState({ loading: true });
  }
}
